export { SegmentLogo as default } from './SegmentLogo';